import { useCallback, useEffect, useRef, useState } from "react";
import Toast from "@/components/base/Toast";
import TopTicker from "./components/TopTicker";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EntryStatus from "./components/EntryStatus";
import Ranking from "./components/Ranking";
import Collections from "./components/Collections";
import TopicWall from "./components/TopicWall";
import UpdateLog from "./components/UpdateLog";
import Faq from "./components/Faq";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const notify = useCallback((message: string) => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    setToast(message);
    timerRef.current = window.setTimeout(() => setToast(null), 2600);
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <TopTicker />
      <Header onNotify={notify} />
      <main className="w-full">
        <Hero onNotify={notify} />
        <EntryStatus onNotify={notify} />
        <Ranking />
        <Collections onNotify={notify} />
        <TopicWall onNotify={notify} />
        <UpdateLog />
        <Faq />
        <CtaBand onNotify={notify} />
      </main>
      <Footer />
      <Toast message={toast} />
    </div>
  );
}